/* eslint-disable react/prop-types */
import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import type { ColumnProps } from 'reactstrap/types/lib/Col';
import classNames from 'classnames';

interface Props {
  md?: ColumnProps;
  title?: string | React.ReactNode;
  title2?: string | React.ReactNode;
  className?: string;
  titleButton?: React.ReactNode;
  onlyDesktop?: boolean;
  onlyMobile?: boolean;
  children?: React.ReactNode;
}

const Section: React.FC<Props> = ({
  md = 12,
  title,
  title2,
  className,
  children,
  titleButton,
  onlyDesktop,
  onlyMobile,
}) => {
  const classes = classNames({ 'only-desktop': onlyDesktop, 'only-mobile': onlyMobile });

  return (
    <Col lg={md} className={classes}>
      <Card>
        <CardBody className={className}>
          {title && (
            <div className="card__title d-flex align-items-center">
              <div className="d-flex flex-column w-100">
                <div className="d-flex justify-content-between">
                  {typeof title === 'string' ? <h5>{title}</h5> : title}
                  {titleButton && <div className="d-flex">{titleButton}</div>}
                </div>
                {typeof title2 === 'string' ? <h5>{title2}</h5> : title2}
              </div>
            </div>
          )}
          {children}
        </CardBody>
      </Card>
    </Col>
  );
};

export default Section;
